import { injectable, singleton } from 'tsyringe';
import { viewModelMetadata } from './ViewModelMetadata';
export function ViewModel(options = {}) {
    return (target) => {
        if (options === null || options === void 0 ? void 0 : options.singleton) {
            viewModelMetadata.setSingletonViewModel(target.constructor, target);
            singleton()(target);
        }
        else {
            injectable()(target);
        }
    };
}
